import type { CalendarSearchRouteParameters } from './calendarRoutes';
import { onSearchTextChanged, startSearch, startSearchSession } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';
import 'owa-calendar-search-view';

/**
 * The route handler for displaying search view
 */
export default function searchRouteHandler(parameters: CalendarSearchRouteParameters) {
    let { query } = parameters;

    // start search session
    startSearchSession('DeepLink', false, SearchScenarioId.Calendar);

    // set search query input
    onSearchTextChanged(query, SearchScenarioId.Calendar);

    // invoke search
    startSearch('DeepLink', SearchScenarioId.Calendar, false);
}
